import React from "react";
import { Text4 } from "../../../../styles";
import { Icon, Button, Menu, Dropdown } from "antd";
import { PermissionHoc } from "../../../HOC";
import moment from "moment";
import { APPROVAL_STATUS_TYPE, MAKER_ACTION_TYPE } from "../../../../constants";

const PermissableMenuItem = PermissionHoc(Menu.Item, "", {
  is_component: true,
  fallbackComponent: null,
});

export const renderMenuOverlay = (methods, record) => {
  return (
    <Menu>
      <PermissableMenuItem
        className="mr-1"
        size="small"
        onClick={() => methods.toggleDetailsDrawer(record)}
        required_permission="VENDOR_READ"
      >
        View Details
      </PermissableMenuItem>
      <PermissableMenuItem
        className="mr-1"
        size="small"
        onClick={() => methods.approval_action({id: record.id})}
        required_permission="VENDOR_WRITE"
      >
        Approve
      </PermissableMenuItem>
      <PermissableMenuItem
        className="mr-1"
        size="small"
        onClick={() => methods.approval_action({id: record.id})}
        required_permission="VENDOR_WRITE"
      >
        Reject
      </PermissableMenuItem>
    </Menu>
  );
};

export const getApprovalsColumns = (methods, current_user) => [
  {
    title: "Created At",
    key: "created_at",
    render: (record) => <Text4>{record.created_at ? moment(record.issue_date).format("LL") : "---"}</Text4>,
  },
  {
    title: "Name",
    key: "vendor_name",
    render: (record) => <Text4>{record.maker.name || "---"}</Text4>,
  },
  {
    title: "Email ID",
    key: "email",
    render: (record) => (
      <div className="d-flex flex-column">
        <Text4>{record.maker.email || "---"}</Text4>
      </div>
    ),
  },
  {
    title: "Maker Action Type",
    key: "maker_action_type",
    render: (record) => (
      <div className="d-flex flex-column">
        <Text4>{MAKER_ACTION_TYPE[record.maker_action_type].label || "---"}</Text4>
      </div>
    ),
  },
  {
    title: (
      <span className="c-pointer" onClick={methods.toggleStatusInfoDrawer}>
        <span>Status</span>
        <Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" />
      </span>
    ),
    key: "status",
    render: (record) => <Text4>{APPROVAL_STATUS_TYPE[record.status].label || "---"}</Text4>,
  },
  {
    title: "Action",
    key: "action",
    render: (record) => (
      <Dropdown overlay={renderMenuOverlay(methods, record)}>
        <Button>
          Actions <Icon type="down" />
        </Button>
      </Dropdown>
    ),
  },
];

export const approvalTableFilterNodes = () => {
  return [
    {
      label: "Name",
      field: "name",
      placeholder: "Name",
      inputType: "text",
      defaultValue: undefined,
      disabled: false,
    },
    {
      label: "Email",
      field: "email",
      placeholder: "Email",
      inputType: "text",
      width: 200,
      disabled: false,
      defaultValue: undefined,
    }
  ];
};
